module.exports = __webpack_public_path__ + "img/boy.b6cc5c19.svg";